export function languageToLocale(language: string): string {
  if (language === "zh") {
    return "cn";
  } else if (language === "cs") {
    return "cz";
  } else {
    return language;
  }
}
